import React from 'react'
import { useTranslation } from 'react-i18next'
import i18n from '@src/i18n'

import Hero from '../../components/Hero'
import Article from '../../components/Article'
import Section from '../../components/Section'

export interface AIProps {}

const HERO_IMAGE = '/paywalls/ai/hero.png'

const ARTICLES = [
  {
    title: i18n.t('paywalls:ai.articles.dataMapping.title'),
    text: i18n.t('paywalls:ai.articles.dataMapping.text'),
    image: '/paywalls/ai/data-mapping.png',
  },
  {
    title: i18n.t('paywalls:ai.articles.noMiss.title'),
    text: i18n.t('paywalls:ai.articles.noMiss.text'),
    image: '/paywalls/ai/no-miss.png',
  },
  {
    title: i18n.t('paywalls:ai.articles.reports.title'),
    text: i18n.t('paywalls:ai.articles.reports.text'),
    image: '/paywalls/ai/reports.png',
  },
]

export const AI: React.FC<AIProps> = () => {
  const { t } = useTranslation('paywalls', { keyPrefix: 'ai' })
  return (
    <>
      <Hero title={t('hero.title')} image={HERO_IMAGE} subtitle={t('hero.subtitle')} />
      <Section title={t('section.title')} text={t('section.text')} />
      <div className="flex flex-col gap-6">
        {ARTICLES.map((article, index) => (
          <Article
            key={article.title}
            title={article.title}
            image={article.image}
            text={article.text}
            hasActionButtons={index === ARTICLES.length - 1}
          />
        ))}
      </div>
    </>
  )
}

export default AI
